import { render, staticRenderFns } from "./LateralUserElementClub.vue?vue&type=template&id=40c9431e&"
import script from "./LateralUserElementClub.vue?vue&type=script&lang=js&"
export * from "./LateralUserElementClub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileAvatar } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
installComponents(component, {
  VList,
  VListTile,
  VListTileAvatar,
  VListTileContent,
  VListTileTitle,
})
